var React = require('react');

function Undo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M2.582 2.985h8.508c2.282 0 4.132 1.933 4.132 4.317 0 2.385-1.848 4.317-4.132 4.317H1.584v-.863h9.506c1.828 0 3.306-1.545 3.306-3.454 0-1.908-1.48-3.454-3.306-3.454H2.582l2.273 2.375-.584.61L1 3.417 4.27 0l.585.61-2.273 2.375z","fill":"#877FFF","stroke":"#877FFF","fillRule":"evenodd"}));
}

Undo.displayName = "Undo";

Undo.defaultProps = {"width":"16","height":"13"};

module.exports = Undo;

Undo.default = Undo;
